export default function getVars(params) {
  return cg_vars;
}
